import { createMemoryHistory, createRouter } from 'vue-router'
import migration from './migration';
import irpf from './irpf';
import opening from './opening';
import consultation from './consultation';


function getSubdomain() {
  const host = window.location.hostname;
  const parts = host.split('.')
  if (parts.length >= 2) {
    return parts[0]
  }

  return null
}
const subdomain = getSubdomain()

let routes = [];
switch (subdomain) {
  case 'migracao':
    routes = migration;
    break;
  case 'irpf':
    routes = irpf;
    break;
   case 'abertura':
    routes = opening;
    break;
  case 'consulta':
    routes = consultation;
    break;
}

const router = createRouter({ history: createMemoryHistory(), routes });

export default router;